var _rect, _g, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeAppstore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135,
    height: 40,
    viewBox: "0 0 135 40",
    role: "img",
    "aria-label": "Download on the App Store",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 40,
    rx: 7,
    fill: "currentColor",
    fillOpacity: 0.08
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18,20) scale(0.82) translate(-18,-20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.769 20.301c-.028-3.232 2.64-4.794 2.761-4.869-1.506-2.2-3.847-2.501-4.676-2.531-1.982-.202-3.874 1.176-4.881 1.176-1.007 0-2.558-1.149-4.207-1.118-2.156.033-4.149 1.261-5.259 3.184-2.244 3.893-.575 9.655 1.607 12.816 1.065 1.548 2.329 3.284 3.992 3.222 1.607-.066 2.21-1.04 4.151-1.04 1.942 0 2.491 1.04 4.185.999 1.726-.028 2.82-1.573 3.876-3.126 1.218-1.791 1.726-3.523 1.754-3.614-.038-.017-3.366-1.292-3.303-5.099z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.57 11.327c.887-1.073 1.484-2.562 1.319-4.05-1.274.052-2.82.849-3.73 1.922-.82.949-1.538 2.471-1.345 3.926 1.42.11 2.87-.722 3.756-1.798z",
    fill: "currentColor"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 35,
    y: 12,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, sans-serif",
    fontSize: 9,
    fill: "currentColor",
    letterSpacing: 0.2
  }, "Available on the")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 35,
    y: 29,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, sans-serif",
    fontSize: 17,
    fontWeight: 600,
    fill: "currentColor",
    letterSpacing: -0.3
  }, "App Store")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeAppstore);
export default __webpack_public_path__ + "static/media/badge-appstore.7c74d56ffc24fc1059d54aa235d1eec7.svg";
export { ForwardRef as ReactComponent };